import authModule from '@/store/auth'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import InsurancePayment from '@/Models/InsurancePayment'
import http from '@/services/http'
import TypePaymentInsurance from '@/Models/TypePaymentInsurance'
import * as Helpers from '@/helpers'

//import * as Helpers from '@/helpers'
@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class FormInsurancePayment extends Vue {
  @Prop({ required: false, default: null })
  objRow!: InsurancePayment

  @Prop({ required: false, default: null })
  objDataForm!: InsurancePayment
  @Prop({ required: false, default: null })
  isAction!: string
  //el mae seleccionado
  objInsurancePayment: InsurancePayment = new InsurancePayment()
  loading = false
  date: any = new Date()
  name = ''
  isFileEdit = false
  coinType = [
    { id: 1, name: 'Colones', value: 1 },
    { id: 2, name: 'Dolares', value: 2 },
  ]
  listTypePaymentInsurance: Array<TypePaymentInsurance> = []

  selected!: any
  get is_login(): boolean {
    return authModule.isAuthenticated
  }
  mounted() {
    this.getTypePaymentInsurance()
    if (this.isAction == 'add') {
      this.$set(this, 'objInsurancePayment', this.objDataForm)
      //this.$set(this.objInsurancePayment,'member_number',this.objDataForm.member_number,)
    }
    if (this.objRow && this.isAction == 'edit') {
      this.$set(this, 'objInsurancePayment', this.objRow)
    }
  }
  async confirmation() {
    console.log(this.isAction)
    const insurancePayment = this.insurancePayment(this.objInsurancePayment)
    switch (this.isAction) {
      case 'add':
        await this.createobjInsurancePayment(insurancePayment)
        break
      case 'edit':
        await this.updateobjInsurancePayment(insurancePayment)
        break
      default:
        console.log('ups')
        break
    }
  }
  async createobjInsurancePayment(objInsurancePayment: any) {
    try {
      console.log('xd', this.objInsurancePayment)
      await http.post(
        `/api/insurance/arcr_insurance_payments/`,
        objInsurancePayment,
      )
      this.$buefy.toast.open({
        message: 'Agregado',
        type: 'is-success',
      })
      setTimeout(() => {
        this.loading = false
        this.close()
      }, 1000)
    } catch (error: any) {
      console.error(error.data)
      this.loading = false
      this.$buefy.toast.open({
        message: `Ups!, ha ocurrido un error`,
        type: 'is-danger',
      })
    }
  }
  async updateobjInsurancePayment(objInsurancePayment: any) {
    try {
      await http.put(
        `/api/insurance/arcr_insurance_payments/${this.objRow.id}/`,
        objInsurancePayment,
      )
      this.$buefy.toast.open({
        message: 'Actualizado',
        type: 'is-success',
      })
      setTimeout(() => {
        this.loading = false
        this.close()
      }, 1000)
    } catch (error: any) {
      //console.error(error)
      this.loading = false
      switch (error.response.data.member_number[0]) {
        case 'Ya existe Crm Cliente Archivo con este member number.':
          this.$buefy.toast.open({
            message: `Ya exite un cliente con el mismo numero de miembro`,
            type: 'is-danger',
          })
          break
        default:
          this.$buefy.toast.open({
            message: `Ups!, algo salio mal`,
            type: 'is-danger',
          })
          break
      }
      /* this.$buefy.toast.open({
        message: `Ups!, ha ocurrido un error`,
        type: "is-danger",
      }) */
    }
  }
  async getTypePaymentInsurance() {
    try {
      const res = await http.get(`api/insurance/insurance_payments_methods/`)
      if (!res.data) throw new Error(res.data)
      this.listTypePaymentInsurance = res.data.map((obj: any) => ({
        ...obj,
      }))
    } catch (error) {
      console.error(error)
      this.$buefy.toast.open({
        message: `Ups!, ha ocurrido un error`,
        type: 'is-danger',
      })
    }
  }
  insurancePayment(obj: InsurancePayment) {
    const insurancePayment = {
      id: obj.id,
      member_number_id: obj.member_number,
      identification: obj.identification,
      insurance_id: obj.insurance,
      coin_type: obj.coin_type,
      amount: obj.amount,
      method_payment_id: obj.method_payment,
      date: Helpers.dateFormat_db(obj.date),
      period_from: Helpers.dateFormat_db(obj.period_from),
      period_up_to: Helpers.dateFormat_db(obj.period_up_to),
      observation: obj.observation,
      update_insurance: obj.update_insurance,
    }
    //console.log(insurancePayment)
    return insurancePayment
  }

  close() {
    this.objInsurancePayment = new InsurancePayment()
    this.$emit('cleanForm')
  }
}
